module.exports = __webpack_public_path__ + "static/media/Outbid.8fb895a0.mp3";